$(document).ready(() => {
  $("#modal").on("hidden.bs.modal", function () {
    $(".modal-footer").remove();
  });

  // ANCHOR Gestion de la popup du service mis en avant

  if (typeof popup !== "undefined" && popup) {
    let href = popup.url_popup;
    // Support pour blog.cyclable.com et www.cyclable.com

    if (ajaxurl.url) ajaxurl = ajaxurl.url;

    if (
      ajaxurl &&
      href &&
      !document.cookie.includes("cyclable_popup_displayed=" + popup.uniqId) &&
      popup.display != ""
    ) {
      // request pour get la page d'affichage de la popup// construction de la modale
      jQuery.get(
        ajaxurl,
        {
          action: "get_remote_content",
          href: href,
        },
        function (response) {
          if (response) {
            // ANCHOR Contenu de la popup
            $(".modal-body").html(response);

            // ANCHOR Contenu du CTA
            if (popup.CTA != "") {
              const htmlButton = `<div class="button d-flex justify-center">
								<a title="Accéder au service" target="_blank" rel="nofollow" href="${popup.url_service}" 
									class="btn btn-lg text text-white text-w-semibold text-uppercase btn-primary mb-3 mb-lg-0 mt-1 mt-lg-0">
									${popup.display_text}
								</a>
							</div>`;

              $(".modal-footer").html(htmlButton);
            } else {
              $(".modal-footer").remove();
            }

            // S'il y a du contenu et un CTA, on affiche la popup
            if ($(".modal-body").text().trim()) {
              $("#modal").modal("show");

              // création du cookie
              let date = new Date();
              date.setTime(date.getTime() + 60 * 60 * 1000); // Ajoute 1 heure
              let expires = "; expires=" + date.toUTCString();
              document.cookie =
                "cyclable_popup_displayed=" + popup.uniqId + expires;
            }
          }
        }
      );
    }
  }

  $('a[href^="#"]')
    .not('[href="#"]')
    .not('[href*="#team"]')
    .not('[href="#collapseRowVelo"]')
    .on("click touch", function (event) {
      event.preventDefault();
      $("#menu").addClass("invisible");
      $("header").removeClass("h-100");
      var hash = this.hash;
      var $target = $(hash);
      if (1 || hash != "#velos") {
        $("html, body").animate(
          {
            scrollTop: $target.offset().top - $("header").innerHeight(), // Scroll to this location.
          },
          {
            // At each animation step, check whether the target has moved.
            step: function (now, fx) {
              // Where is the target now located on the page?
              // i.e. its location will change as images etc. are lazy loaded
              var newOffset = $target.offset().top - $("header").innerHeight();

              // If where we were originally planning to scroll to is not
              // the same as the new offset (newOffset) then change where
              // the animation is scrolling to (fx.end).
              if (fx.end !== newOffset) fx.end = newOffset;
            },
          },
          500,
          function () {
            window.location.hash = hash;
          }
        );
      } else {
        $("html, body").animate(
          {
            scrollTop: $target.offset().top - 300,
          },
          {
            // At each animation step, check whether the target has moved.
            step: function (now, fx) {
              // Where is the target now located on the page?
              // i.e. its location will change as images etc. are lazy loaded
              var newOffset = $target.offset().top - 300;

              // If where we were originally planning to scroll to is not
              // the same as the new offset (newOffset) then change where
              // the animation is scrolling to (fx.end).
              if (fx.end !== newOffset) fx.end = newOffset;
            },
          },
          500,
          function () {
            window.location.hash = hash;
          }
        );
      }

      setTimeout(function () {
        $("#menu").removeClass("invisible");

        if (hash != "#velos" && hash != "#horaires")
          $("header").removeClass("headroom--unpinned");
      }, 400);
    });

  // Fermeture de la popup

  $("#modal").on("hide.bs.modal", function (e) {
    $(".modal-content").removeClass("bg-mediateur");
    $(".modal-content").removeClass("bg-contact");
    $(".modal-body").html(
      '<div class="spinner-border text-dark" role="status"></div>'
    );
    const body = document.body;
    const scrollY = body.style.top;
    body.style.position = "";
    body.style.width = "";
    body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  });
  // Affichage de la popup

  $("#modal").on("show.bs.modal", function (e) {
    const scrollY =
      document.documentElement.style.getPropertyValue("--scroll-y");
    const body = document.body;
    body.style.position = "fixed";
    body.style.width = "100%";
    body.style.top = `-${scrollY}`;
  });

  window.addEventListener("scroll", () => {
    document.documentElement.style.setProperty(
      "--scroll-y",
      `${window.scrollY}px`
    );
  });

  //Full screen menu

  $("#menu").show();
  $("#menu-search").show();
  $("#cd-navigation").removeClass("invisible");
  $(".cc-window").show();

  $("#menu a:not(.link-new-page)").on("click touch", function () {
    if ($("#menu").hasClass("opened")) {
      href = $(this);
      $(".cd-auto-hide-header .icon-close").toggleClass("icon-open icon-close");
      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = "";
      body.style.width = "";
      body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
      $("#menu").scrollTop(0);

      var hash = this.hash;

      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top,
        },
        500,
        function () {
          window.location.hash = hash;
          $("header").removeClass("headroom--unpinned");
        }
      );

      $("#menu")
        .removeClass("opened")
        .one(
          "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
          function () {}
        );
    }
  });

  $("#toggle").on("click touch", function () {
    $("div", this).toggleClass("icon-open icon-close");

    if ($("#menu").hasClass("opened")) {
      $("#menu")
        .removeClass("opened")
        .one(
          "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
          function () {
            const body = document.body;
            const scrollY = body.style.top;
            body.style.position = "";
            body.style.width = "";
            body.style.top = "";
            window.scrollTo(0, parseInt(scrollY || "0") * -1);
            $("#menu").scrollTop(0);

            setTimeout(function () {
              $("header").removeClass("h-100");
            }, 400);

            $("header").headroom({
              offset: 50,
              tolerance: 0,
              onTop: function () {
                $(".cd-annonces-exceptionnelles").fadeIn("slow");
              },
              onNotTop: function () {
                $(".cd-annonces-exceptionnelles").fadeOut("fast");
              },
            });
          }
        );
    } else {
      $("header").addClass("h-100");

      $("#menu")
        .addClass("opened")
        .one(
          "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
          function () {
            const scrollY =
              document.documentElement.style.getPropertyValue("--scroll-y");
            const body = document.body;
            body.style.position = "fixed";
            body.style.width = "100%";
            body.style.top = `-${scrollY}`;

            $("header").headroom("destroy");
          }
        );
    }
  });

  //End Full screen menu

  $(".btn-action").on("click touch", function () {
    //Remove the icon class
    if ($(this).find("i").hasClass("icon-moins")) {
      //then change back to the original one
      $(this)
        .find("i")
        .removeClass("icon-moins")
        .addClass($(this).data("icon-name"));
    } else {
      //Remove the cross from all other icons
      $(".btn-action").each(function () {
        if ($(this).find("i").hasClass("icon-moins")) {
          $(this)
            .find("i")
            .removeClass("icon-moins")
            .addClass($(this).data("icon-name"));
        }
      });
      $(this)
        .find("i")
        .addClass("icon-moins")
        .removeClass($(this).data("icon-name"));
    }
  });

  //End Member Team Click event

  var swiper2 = new Swiper(".slider-menu-open .swiper-container", {
    slidesPerView:
      $(window).width() < 576
        ? 1.2
        : $(window).width() < 1200
        ? 1
        : $(window).width() < 1600
        ? 1
        : 1,
    spaceBetween: 30,
    loop: false,
    pagination: {
      el: ".slider-menu-open .swiper-pagination",
      clickable: true,
    },
    keyboard: {
      enabled: false,
      onlyInViewport: false,
    },
  });

  var swiper20 = new Swiper(".slider-nos-services-velos .swiper-container", {
    slidesPerView:
      $(window).width() < 576
        ? 2.5
        : $(window).width() < 768
        ? 3.5
        : $(window).width() < 1200
        ? 4.4
        : $(window).width() < 1600
        ? 5
        : 5,
    spaceBetween: 30,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: ".slider-nos-services-velos .swiper-next",
      prevEl: ".slider-nos-services-velos .swiper-prev",
    },
    pagination: {
      el: ".slider-nos-services-velos .swiper-pagination",
      clickable: true,
    },
    keyboard: {
      enabled: false,
      onlyInViewport: false,
    },
  });

  //All Sliders end

  //Sticky Header mobile

  $(window).on("resize", function (e) {
    checkScreenSize();
  });

  checkScreenSize();

  function checkScreenSize() {
    var newWindowWidth = $(window).width();

    if (newWindowWidth < 576) {
      $(".menu-fix").appendTo("footer");
    } else {
    }
  }

  //End Sticky Header mobile

  // Back to Top

  (function () {
    var backTop = document.getElementsByClassName("js-cd-top")[0],
      offset = 300, // browser window scroll (in pixels) after which the "back to top" link is shown
      offsetOpacity = 1200, //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
      scrollDuration = 700,
      scrolling = false;

    if (backTop) {
      //update back to top visibility on scrolling
      window.addEventListener("scroll", function (event) {
        if (!scrolling) {
          scrolling = true;
          !window.requestAnimationFrame
            ? setTimeout(checkBackToTop, 250)
            : window.requestAnimationFrame(checkBackToTop);
        }
      });
    }

    function checkBackToTop() {
      var windowTop = window.scrollY || document.documentElement.scrollTop;
      windowTop > offset
        ? $(".js-cd-top").addClass("cd-top--is-visible")
        : $(".js-cd-top").removeClass("cd-top--is-visible cd-top--fade-out");
      windowTop > offsetOpacity && $(".js-cd-top").addClass("cd-top--fade-out");
      scrolling = false;
    }
  })();

  $('a[data-modal="location"]').on("click touch", function (e) {
    e.preventDefault();

    jQuery.get(
      ajaxurl,
      {
        action: "get_location_content",
      },
      function (response) {
        $(".modal-body").html(response);
      }
    );
  });

  $(".partage").on("click touch", function (e) {
    $(this).toggleClass("clicked");
  });

  $("a.modal-remote").on("click touch", function (e) {
    e.preventDefault();

    if ($(".modal-footer.popup").length !== 0) {
      $(".modal-footer.popup").remove();
    }

    var href = $(this).attr("href");

    jQuery.get(
      ajaxurl,
      {
        action: "get_remote_content",
        href: href,
      },
      function (response) {
        $(".modal-body").html(response);
        if (href.match(/mediateur/)) {
          $(".modal-content").addClass("bg-mediateur");
        }
      }
    );
  });

  // magasin.cyclable.com/#cgv will open the cgv popup
  if ($(location).attr("hash").toLowerCase() == "#cgv") {
    $('a[title="C.G.V"]').click();
  }

  $("a.iframe").on("click touch", function (e) {
    e.preventDefault();
    $(".modal-content").addClass("bg-contact");
    $(".modal-body").html(
      '<iframe class="contact" src="' + $(this).attr("href") + '">'
    );
  });

  $("#signupNewsletter").on("click touch", function (e) {
    e.preventDefault();
    tlite.hide(document.querySelector(".tlite-container"));
    $("#signupNewsletter").prop("title", "");

    if (!$("#customCheck1").is(":checked")) {
      tlite((el) => el.classList.contains("tlite-container"));
      $("#signupNewsletter").prop("title", "Vous devez cocher la case.");

      tlite.show(document.querySelector(".tlite-container"), {
        grav: "se",
      });

      setTimeout(function () {
        tlite.hide(document.querySelector(".tlite-container"));
      }, 4000);
    } else {
      jQuery.get(
        ajaxurl,
        {
          action: "signup_newsletter",
          emailAddress: $("#emailAddress").val(),
        },
        function (response) {
          tlite((el) => el.classList.contains("tlite-container"));
          $("#signupNewsletter").prop("title", response);

          tlite.show(document.querySelector(".tlite-container"), {
            grav: "se",
          });

          setTimeout(function () {
            tlite.hide(document.querySelector(".tlite-container"));
            $("#signupNewsletter").prop("title", "");
          }, 4000);
        }
      );
    }
  });

  $("#emailAddress").keypress(function (event) {
    tlite.hide(document.querySelector(".tlite-container"));
    $("#signupNewsletter").prop("title", "");
    var keycode = event.keyCode ? event.keyCode : event.which;
    if (keycode == "13") {
      if (!$("#customCheck1").is(":checked")) {
        tlite((el) => el.classList.contains("tlite-container"));
        $("#signupNewsletter").prop("title", "Vous devez cocher la case.");

        tlite.show(document.querySelector(".tlite-container"), {
          grav: "se",
        });

        setTimeout(function () {
          tlite.hide(document.querySelector(".tlite-container"));
        }, 4000);
      } else {
        jQuery.get(
          ajaxurl,
          {
            action: "signup_newsletter",
            emailAddress: $("#emailAddress").val(),
          },
          function (response) {
            tlite((el) => el.classList.contains("tlite-container"));
            $("#signupNewsletter").prop("title", response);

            tlite.show(document.querySelector(".tlite-container"), {
              grav: "se",
            });

            setTimeout(function () {
              tlite.hide(document.querySelector(".tlite-container"));
              $("#signupNewsletter").prop("title", "");
            }, 4000);
          }
        );
      }
    }
    event.stopPropagation();
  });

  $(".swiper-container").hover(
    function () {
      this.swiper.autoplay.stop();
    },
    function () {
      this.swiper.autoplay.start();
    }
  );

  $(".swiper-container").css("visibility", "visible");

  $("#group").css("visibility", "visible");

  $(".bloc-nos-clients-parlent-de-nous").css("visibility", "visible");

  $("header").headroom({
    offset: 50,
    tolerance: 0,
    onTop: function () {
      $(".cd-annonces-exceptionnelles").fadeIn("slow");
    },
    onNotTop: function () {
      $(".cd-annonces-exceptionnelles").fadeOut("fast");
    },
  });
});

(() => {
  const webShareTestEl = document.querySelector(".wsapi");

  let resetTimeout;

  const getOpenGraphData = function (property) {
    return document
      .querySelector(`meta[property="${property}"]`)
      .getAttribute("content");
  };

  const sharePage = () => {
    navigator
      .share({
        title: getOpenGraphData("og:title"),
        text: getOpenGraphData("og:description"),
        url: getOpenGraphData("og:url"),
      })
      .then(() => {
        if (webShareTestEl) {
          webShareTestEl.children[0].innerText = "done";
        }
      })
      .catch((error) => {
        console.log("Error sharing:", error);
        if (webShareTestEl) {
          webShareTestEl.children[0].innerText = "error";
        }
      });
  };

  // EVENTS
  if (webShareTestEl) {
    webShareTestEl.addEventListener("click", sharePage);
  }
})();
